import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "accordion__label" }
const _hoisted_2 = { class: "accordion__body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["accordion", { 'accordion--open': _ctx.open }])
  }, [
    _createElementVNode("div", {
      class: "accordion__header",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open = !_ctx.open))
    }, [
      _renderSlot(_ctx.$slots, "header", {}, () => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.label), 1)
      ], true),
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "accordion__chevron" }, "›", -1))
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 512), [
      [_vShow, _ctx.open]
    ])
  ], 2))
}